

export const environment = {
  production: false,
  version: '2023.1',
  baseUrl: 'https://syntaxmigrator-staging.beinex.com/',
  cookieDomain:'https://tss.beinex.com/',
  apiVersion: 'api/v1/',
};
